import { useCallback } from 'react';
import { usePredefinedCommentFormContext } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/hooks/use-predefined-comment-form-context.hook';
import { usePredefinedCommentDataHandler } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/hooks/use-predefined-comment-data-handler.hook';
import { usePredefinedCommentSaver } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/hooks/use-predefined-comment-saver.hook';

export const usePredefinedCommentForm = () => {
    const { mode, isFormLoading, predefinedCommentId, predefinedComment } = usePredefinedCommentFormContext();
    const {
        formData,
        handleDataChange,
        handleAddDeviceTypeEntry,
        handleRemoveDeviceTypeEntry,
        handleEntryChange,
        unsavedData,
        isDataValid,
        handleOnClose,
    } = usePredefinedCommentDataHandler();
    const { savePredefinedComment, editPredefinedComment } = usePredefinedCommentSaver();

    const handleSave = useCallback(() => {
        savePredefinedComment(formData).then(() => {
            unsavedData.setIsUnsavedChanges(false);
        });
    }, [savePredefinedComment, formData, unsavedData]);

    const handleEdit = useCallback(() => {
        editPredefinedComment(formData).then(() => {
            unsavedData.setIsUnsavedChanges(false);
        });
    }, [editPredefinedComment, formData, unsavedData]);

    return {
        // Context
        mode,
        isFormLoading,
        predefinedCommentId,
        predefinedComment,
        // Data handler
        formData,
        handleDataChange,
        handleAddDeviceTypeEntry,
        handleRemoveDeviceTypeEntry,
        handleEntryChange,
        unsavedData,
        isDataValid,
        handleOnClose,
        // Submission
        handleSave,
        handleEdit,
    };
};
